import { Component, OnInit, OnDestroy, signal, inject, computed, effect, ChangeDetectionStrategy } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { CoreService, NotificationService } from '../../services'
import { printPurchaseExportsColumns } from '../../utils/definitions.util'
import { SchemaUtil } from '../../utils'
import { TranslateService } from '@ngx-translate/core'
import { injectInfiniteQuery, injectMutation } from '@tanstack/angular-query-experimental'
import { PurchaseExportService } from '../../services/entity-services/purchaseExport.service'

@Component({
  selector: 'app-print-purchase-exports',
  templateUrl: 'print-purchase-exports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrintPurchaseExportsComponent extends BaseListing implements OnInit, OnDestroy {
  private purchaseExportService = inject(PurchaseExportService)

  listingColumns = signal(printPurchaseExportsColumns)
  reports: any[] = []
  totalItems = computed(() => {
    console.error(this.queryPurchaseOrderExports.data())
    return 100
  })
  currentPage: number
  endPage: number
  refreshInterval: any = null
  loading = true
  // storageKey: WritableSignal<{ type: string; key: string }> = signal({ type: '', key: '' })
  sortProp = signal('created')
  sortDir = signal('desc')

  readonly queryPurchaseOrderExports = injectInfiniteQuery(() => ({
    queryKey: ['purchaseOrdersExports', { sortProp: this.sortProp(), sortDir: this.sortDir() }], // todo add  queryKey -> sort, filters, schema - columns
    queryFn: async ({ pageParam }) => {
      // const requestId = ++this.currentRequestId // unique ID per call
      // todo. disable for now - querySelectorAll gets all inputs from pages, even when they should be destroyed. (looking at you, Products form fields!)
      return await this.purchaseExportService
        .getPurchaseExport(
          {
            page: pageParam,
            sort: this.sortProp(),
            direction: this.sortDir(),
          },
          SchemaUtil.purchase
        )
        .then(result => {
          return result
        })
    },
    initialPageParam: 1,
    getNextPageParam: result => {
      return Number(result?.paginator?.current) < Number(result?.paginator?.endPage)
        ? Number(result?.paginator?.current) + 1
        : undefined
    },
  }))

  createPurchaseExport = injectMutation(() => ({
    mutationFn: async (exportToCreate: any) => {
      return await this.purchaseExportService.createPurchaseExport(exportToCreate, { id: null })
    },
    onSuccess: data => {
      this.notificationService.success(this.translateService.instant('alert.export.created'))
      this.queryPurchaseOrderExports.refetch()
    },
  }))

  constructor(
    protected core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
    super(core)
    effect(() => {
      this.queryPurchaseOrderExports.data()
    })
    // this.getStorageKey()
  }

  ngOnInit() {
    this.loadSorting('printPurchaseExports')
  }

  ngOnDestroy() {
    this.stopRefreshing()
  }

  downloadReport(report: any) {
    this.core.services.download.downloadDocumentAndShowInNewWindow(report.url)
  }
}
